import { useEffect, useState } from 'react';
import { getShippingQuote, type ShippingQuote } from '../api/client';

/** The delivery the server chose for a cart: what it is called, what it costs and how long it takes. */
export type SelectedRate = ShippingQuote['selectedRate'];

// The whole rate the server chose, or null while it is still unknown.
export function useShippingRate(subtotal: number, countryCode: string): SelectedRate | null {
  const [rate, setRate] = useState<SelectedRate | null>(null);

  useEffect(() => {
    let cancelled = false;
    setRate(null);
    getShippingQuote(subtotal, countryCode)
      .then((quote) => {
        if (!cancelled) setRate(quote.selectedRate);
      })
      .catch(() => {
        // A failed quote leaves the fee unknown rather than guessing one the order will not charge
        if (!cancelled) setRate(null);
      });
    return () => {
      cancelled = true;
    };
  }, [subtotal, countryCode]);

  return rate;
}

// The delivery fee as the server prices it, or null while it is still unknown.
export function useShippingQuote(subtotal: number, countryCode: string): number | null {
  const rate = useShippingRate(subtotal, countryCode);
  return rate === null ? null : rate.price;
}
